// The same shell index.html paints before any code arrives (its look is in index.html's head), shown while the
// sign-in code or the pages load, so the screen never goes blank in between.
export function BootShell() {
  return (
    <div className="boot">
      <header>Stockroom</header>
      <p role="status">Loading…</p>
    </div>
  );
}
